<template>
    <v-col align-self="center">
        <v-row>
            <v-col>
                <img src="../../assets/images/1756393d5da10cdee7ab7b90dda94f9e.jpg" alt="" style="object-position: center top;">
            </v-col>
            <v-col>
                <img src="../../assets/images/fnac-unibet-notre-classement-des-enseignes-de-loisirs-et-de-la-culture-1258666.jpg" alt="" style="object-position: center top;">
            </v-col>
        </v-row>
        <v-row>
            <v-col>
                <img src="../../assets/images/Nos-produits507599faaf74f.jpg" alt="" style="object-position: center top;">
            </v-col>
            <v-col>
                <img src="../../assets/images/pose-enseigne-angers-adhesif-vitrine-9.jpg" alt="" style="object-position: center 35%;">
            </v-col>
        </v-row>
    </v-col>
</template>

<script>
export default {
    name: 'DefaultImages',
    components: {},
    mixins: [],
    props: {},
    data() {
        return {};
    },
    computed: {},
    watch: {},
    created() {

    },
    methods: {},
}
</script>

<style scoped>
img {
    height: 20vh;
    width: 100%;
    object-fit: cover;
}
</style>



// WEBPACK FOOTER //
// src/components/Simulateur/DefaultImages.vue